
// import React, { useState } from 'react';
// import { Product } from '../types/types';
// import Lightbox from './Lightbox';

// interface ProductCardProps extends Product {
//   onLoad?: () => void;
// }

// const ProductCard: React.FC<ProductCardProps> = ({
//   name,
//   category,
//   description,
//   ref: productRef,
//   tag,
//   badge,
//   featured,
//   images,
//   onLoad,
// }) => {
//   const [imageLoaded, setImageLoaded] = useState(false);
//   const [imageError, setImageError] = useState(false);
//   const [lightboxOpen, setLightboxOpen] = useState(false);

//   const fallbackImage = "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&h=700&fit=crop&auto=format";

//   const handleImageLoad = () => {
//     setImageLoaded(true);
//     setImageError(false);
//     if (onLoad) onLoad();
//   };

//   const handleImageError = () => {
//     setImageError(true);
//     setImageLoaded(false);
//     console.error(`Erreur chargement image: ${name}`);
//   };

//   const openLightbox = () => setLightboxOpen(true);
//   const closeLightbox = () => setLightboxOpen(false);

//   return (
//     <>
//       <div className="bg-dark border border-mid relative overflow-hidden transition-all duration-300 hover:border-silver hover:-translate-y-1 group">
//         <div 
//           className={`w-full ${featured ? 'aspect-[16/9]' : 'aspect-[3/4]'} bg-darkMid relative overflow-hidden cursor-pointer`} 
//           onClick={openLightbox}
//         >
//           {/* Image principale (première du tableau) */}
//           <img
//             src={images?.[0] || fallbackImage}
//             alt={name}
//             className={`w-full h-full object-cover transition-opacity duration-500 ${
//               imageLoaded && !imageError ? 'opacity-100' : 'opacity-0'
//             }`}
//             onLoad={handleImageLoad}
//             onError={handleImageError}
//           />

//           {/* Placeholder pendant le chargement */}
//           {(!imageLoaded || imageError) && (
//             <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#1a1a1a] via-[#222222] to-[#1a1a1a]">
//               <svg className="w-12 h-12 opacity-20" viewBox="0 0 24 24" fill="none" stroke="#888">
//                 <rect x="3" y="3" width="18" height="18" rx="2" />
//                 <circle cx="8.5" cy="8.5" r="1.5" />
//                 <polyline points="21 15 16 10 5 21" />
//               </svg>
//               <span className="text-[9px] tracking-[3px] uppercase text-mid">
//                 {imageError ? 'Image non disponible' : 'Chargement...'}
//               </span>
//             </div>
//           )}

//           {/* Badge éventuel */}
//           {badge && (
//             <span className="absolute top-3 left-3 bg-gold text-black text-[8px] tracking-[2px] uppercase px-2.5 py-1.5 font-semibold z-10">
//               {badge}
//             </span>
//           )}

//           {/* Indicateur du nombre de photos */}
//         {images && images.length > 1 && (
//   <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full">
//     {images.length} photos
//   </div>
// )}
      
//         </div>

//         <div className="p-5 pt-4 border-t border-mid">
//           <div className="text-[8px] tracking-[3px] uppercase text-gold mb-2">
//             {category === 'essential' ? 'Essential · Pantalons' : category === 'urban' ? 'Urban · Pantalons' : 'Classique · Pantalons'}
//           </div>
//           <h4 className="font-serif text-xl font-semibold text-white tracking-[0.03em] mb-1.5">
//             {name}
//           </h4>
//           <p className="text-[11px] text-silver leading-relaxed mb-3.5 whitespace-pre-line">
//             {description}
//           </p>
//           <div className="flex items-center justify-between">
//             <span className="text-[9px] tracking-[2px] text-mid uppercase">
//               Réf: {productRef}
//             </span>
//             <span className="text-[8px] tracking-[2px] uppercase text-silver border border-mid px-2 py-0.5">
//               {tag}
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Lightbox */}
//       {lightboxOpen && (
//         <Lightbox
//           images={images || [fallbackImage]}
//           initialIndex={0}
//           onClose={closeLightbox}
//         />
//       )}
//     </>
//   );
// };

// export default ProductCard;


import React, { useState } from 'react';
import { Product } from '../types/types';
import Lightbox from './Lightbox';

interface ProductCardProps extends Product {
  onLoad?: () => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  name,
  category,
  description,
  ref: productRef,
  tag,
  badge,
  featured,
  images,
  onLoad,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const fallbackImage = "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&h=700&fit=crop&auto=format";

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
    if (onLoad) onLoad();
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
    console.error(`Erreur chargement image: ${name}`);
  };

  const openLightbox = () => setLightboxOpen(true);
  const closeLightbox = () => setLightboxOpen(false);

  // Détermine si le produit est un ensemble (pour affichage)
  const isEnsemble = name.toLowerCase().includes('ensemble');

  return (
    <>
      <div className="bg-dark border border-mid relative overflow-hidden transition-all duration-300 hover:border-silver hover:-translate-y-1 group">
        <div 
          className={`w-full ${featured ? 'aspect-[16/9]' : 'aspect-[3/4]'} bg-darkMid relative overflow-hidden cursor-pointer`} 
          onClick={openLightbox}
        >
          {/* Image principale */}
          <img
            src={images?.[0] || fallbackImage}
            alt={name}
            className={`w-full h-full object-cover transition-opacity duration-500 ${
              imageLoaded && !imageError ? 'opacity-100' : 'opacity-0'
            }`}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />

          {/* Placeholder */}
          {(!imageLoaded || imageError) && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#1a1a1a] via-[#222222] to-[#1a1a1a]">
              <svg className="w-12 h-12 opacity-20" viewBox="0 0 24 24" fill="none" stroke="#888">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span className="text-[9px] tracking-[3px] uppercase text-mid">
                {imageError ? 'Image non disponible' : 'Chargement...'}
              </span>
            </div>
          )}

          {/* Badge */}
          {badge && (
            <span className="absolute top-3 left-3 bg-gold text-black text-[8px] tracking-[2px] uppercase px-2.5 py-1.5 font-semibold z-10">
              {badge}
            </span>
          )}

          {/* Indicateur du nombre de photos */}
          {images && images.length > 1 && (
            <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full">
              {images.length} photos
            </div>
          )}
        </div>

        <div className="p-5 pt-4 border-t border-mid">
          <div className="text-[8px] tracking-[3px] uppercase text-gold mb-2">
            {category === 'essential' ? 'Essential' : category === 'urban' ? 'Urban' : 'Classique'}
            {' · '}
            {isEnsemble ? 'Ensembles' : 'Pantalons'}
          </div>
          <h4 className="font-serif text-xl font-semibold text-white tracking-[0.03em] mb-1.5">
            {name}
          </h4>
          <p className="text-[11px] text-silver leading-relaxed mb-3.5 whitespace-pre-line">
            {description}
          </p>
          <div className="flex items-center justify-between">
            <span className="text-[9px] tracking-[2px] text-mid uppercase">
              Réf: {productRef}
            </span>
            <span className="text-[8px] tracking-[2px] uppercase text-silver border border-mid px-2 py-0.5">
              {tag}
            </span>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <Lightbox
          images={images || [fallbackImage]}
          initialIndex={0}
          onClose={closeLightbox}
        />
      )}
    </>
  );
};

export default ProductCard;